import { useEffect } from "react";

import { CommonRoutesConfig } from "../RoutesConfig";
import authenticationService from "../../services/authenticationService";
import { Navigate } from "react-router-dom";

export default function Logout() {
  useEffect(() => {
    authenticationService.logout();
  }, []);

  return (
    <Navigate
      to={{
        pathname: CommonRoutesConfig.Login.Path,
      }}
      replace={true}
    />
  );
}
